import Home from "./home/Home";
import Administrators from "./administrator/Administrators";
import Registration from "./registration/Registration";
import ConfirmRegister from "./registration/ConfirmRegister";
import ConfirmData from "./administrator/ConfirmData";
import Contacts from "./contacts/Contacts";
import Faq from "./faq/Faq";
import NotFound from "./notfound/NotFound";
import { Routes,Route } from 'react-router-dom'; 

export default function Main() {
  	return (
		  	<Routes>
		  	    <Route exact path="*" element={<NotFound />} />
		  	    <Route exact path="/error" element={<NotFound />} />
		  		<Route exact path='/' element={< Home />}></Route>
		  		<Route exact path='/home' element={< Home />}></Route>
		  		<Route exact path='/administrator' element={< Administrators />}></Route>
		  		<Route exact path='/registration' element={< Registration />}></Route>
		  		<Route exact path='/contacts' element={< Contacts />}></Route>
		  		<Route exact path='/faq' element={< Faq />}></Route>
		  		<Route exact path='/confirm-administrator' element={< ConfirmRegister />}></Route>
		  		<Route exact path='/confirm-data' element={< ConfirmData />}></Route>
		  		<Route exact path='/confirm-company' element={< ConfirmRegister />}></Route>
		  	</Routes>		  
	);
}